import { Table } from 'react-bootstrap';
import styled from 'styled-components';

import { colorScheme } from '../../theme';

export const FlatTable = styled(Table)`
  color: ${colorScheme.text.base};
  tr:nth-of-type(odd) td {
    background: ${colorScheme.globalBackground};
  }

  tr:hover td {
    background: ${colorScheme.globalBackground};
  }

  td {
    transition: 150ms ease background;
  }
`;
